import { useState, useEffect } from 'react';
import { preloadImage, isPlatformNodeJS, generateSrcSet } from '@utils/common';
import { isImageCached } from '../components/postloaded-image.js';

function useLoadedImage(args) {
  const [img, setImg] = useState(isImageCached(args) ? createImage(args) : undefined);
  useEffect(() => {
    if (isImageCached(args)) {
      setImg(createImage(args));
    } else {
      preloadImage(args.src, args.sizes, args.maxWidth).then(img => setImg(img));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [args.maxWidth, args.sizes, args.src]);
  return img;
}
function createImage(args) {
  if (!args.src || isPlatformNodeJS()) {
    return undefined;
  }
  const img = new Image();
  img.src = args.src;
  if (args.src && args.sizes) {
    img.sizes = args.sizes;
    img.srcset = generateSrcSet(args.src, args.maxWidth);
  }
  return img;
}

export { useLoadedImage };
//# sourceMappingURL=image.js.map
